/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Business_Form_SubtitleInputs */

const en_business_form_subtitle = /** @type {(inputs: Business_Form_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interested in Listening for your organization? Leave your details and our team will reach out.`)
};

const es_business_form_subtitle = /** @type {(inputs: Business_Form_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Interesado en Listening para tu organización? Deja tus datos y nuestro equipo se pondrá en contacto.`)
};

/**
* | output |
* | --- |
* | "Interested in Listening for your organization? Leave your details and our team will reach out." |
*
* @param {Business_Form_SubtitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const business_form_subtitle = /** @type {((inputs?: Business_Form_SubtitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Business_Form_SubtitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_business_form_subtitle(inputs)
	return en_business_form_subtitle(inputs)
});